import {css} from "styled-components";

const ModalsCss = css`
.modal {
  .modal-dialog {
    width: 600px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    .modal-content {
      padding: 20px;
      max-width: 100%;

      .modal-footer, .modal-body, .modal-header {
        padding-left: 0;
        padding-right: 0;
      }

      .modal-header {
        button.close {
          position: absolute;
          top: 100px;
          right: 15px;
          font-size: 35px;
          font-weight: 100;
          color: #bbb;
          line-height: 0;
        }

        h2, h3 {
          font-weight: 900;
        }
        h2 {
          font-size: 35px;
        }

        h3 {
          font-size: 30px;
        }
      }

      .modal-body {
        padding-bottom: 5px;
      }

      .modal-footer {
        border: none;
        padding-bottom: 0;
        padding-top: 10px;
      }

      .close-btn {
        position: absolute;
        top: 15px;
        right: 15px;
        border: none;
        background: none;
        font-size: 22px;
        font-weight: 100;
        color: #bbb;
        line-height: 0;

        img {
          height: 20px;
          width: auto;
        }
      }
    }

    .custom-modal-content {
      width: 389px;
    }
  }

  &.bye-lausanne-modal {
    display: flex !important;
    justify-content: center;
    align-items: center;

    .modal-dialog {
      width: 691px;
      max-width: 100%;
    }
  }

  &.farmy-zipcode-modal {
    .modal-dialog {
      max-width: 440px;
    }
  }

  &.also-bought-products-modal {
    .modal-dialog {
      width: auto;
      .modal-content {
        width: 1125px;
        max-width: 100%;
      }
    }
  }
}

@media (max-width: 767px) {
  .modal .modal-dialog {
    width: 100%;
    padding: 10px;
  }

  .modal.bye-lausanne-modal {
    display: block !important;
  }

  .custom-modal-content {
    width: 297px;
  }
}

.modal.fade.show, .modal-backdrop.fade.show {
  opacity: 1;
}`;

export default ModalsCss;
